<template>
    <div>
        <gofix-default-table
                class="noFullHeight scrollAbsolute"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="newItem"
                @row-click="updateHeadleadModal"
                @delete-items="deleteItems"
                ref="gofixTable">
            <template slot="gofix_table:start_date" slot-scope="row">
                {{ row.item.start_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:end_date" slot-scope="row">
                {{ row.item.end_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
            </template>
            <template slot="gofix_table:option_end_date" slot-scope="row">
                {{ row.item.option_end_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY")}}
            </template>
        </gofix-default-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="models.title" hide-footer :centered="true" v-model="models.open" @hidden="hiddenModel">
            <b-form class="pb-20">
                <gofix-form-dropdown
                        label="Head Lease"
                        :options="optionsHeadLease"
                        v-model="models.data.head_lease"
                        vLabel="lease_id">
                        <template #gofixInput:dropdown:option="{ id, description }">
                            {{ id }} - {{ description }}
                        </template>
                        <template #gofixInput:dropdown:selected-option="{ id, description }">
                            {{ id }} - {{ description }}
                        </template>
                </gofix-form-dropdown>
                <gofix-form-properties
                        label="Property"
                        :contract-id="$route.params.id"
                        search-nested
                        v-model="models.data.property"
                        valueFormat="object">
                </gofix-form-properties>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="createHeadLease" :loading="models.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js';

    export default {
        name: 'head-lease',
        components: {},
        data () {
            let filter = JSON.parse(JSON.stringify(filters['head_lease']));
            return {
                tableConfig:{
                    name: 'finance-head-lease',
                    controls:{
                        create: this.$checkRole(this.$accessModule.client_contract_finance, 'create'),
                        createTooptip:"Assign Head Lease",
                        delete: this.$checkRole(this.$accessModule.client_contract_finance, 'delete'),
                        tableExport: false
                    },
                    filter: filter,
                    first_load: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortDirection: "asc",
                    itemSelected: []
                },
                tableItems:[],
                optionsHeadLease: [],
                lease_id_old: null,
                models:{
                    open: false,
                    loading: false,
                    title:"Assign Head Lease",
                    data:{
                        head_lease: null,
                        property_id: null,
                        client_contract_id: this.$route.params.id,
                        property: null,
                    },
                    properties : {
                        data: [],
                        loading: false
                    }
                },
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                currentRoles: 'AuthController/roles'
            }),
        },
        watch: {
            "currentRoles": function(val,old){
                this.tableConfig.controls = {
                    create: this.$checkRole(this.$accessModule.client_contract_finance, 'create'),
                    createTooptip:"Assign Head Lease",
                    delete: this.$checkRole(this.$accessModule.client_contract_finance, 'delete')
                }
            },
            "ClientContractID.id" : function(val,old){
                if(old && old !== val){
                    if(val){
                        this.loadproperty(val);
                        this.models.data.client_contract_id = val;
                    }else{
                        return this.$router.push('/v2/contract-client')
                    }
                }
            }
        },
        created() {
            //this.loadproperty();
        },
        methods:{
            /*---------------------Fm code------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                  // if(this.first_load){
                  //   this.first_load = false;
                  //   resolve();
                  //   return;
                  // }

                await this.$store.dispatch("PropertyHeadLeaseController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load items", "danger");
                        reject();
                    })
                await this.$store.dispatch("PropertyHeadLeaseController/getItems", {filter: {property_id: 0}})
                    .then(response => {
                        this.optionsHeadLease = response.items;
                        resolve(response);
                    })
                    .catch(err => {
                        reject();
                    })
            },
            updateHeadleadModal(item){
                if(!this.$checkRole(this.$accessModule.client_contract_finance, 'update')){
                    return
                }
                if(this.models.properties.data.length === 0){
                    this.loadproperty();
                }
                this.models.title = 'Assign Head Lease';
                this.models.data = Object.assign({}, {
                    id: item.id,
                    property_id: item.property_id,
                    property: item.property,
                    head_lease: item,
                    client_contract_id: this.$route.params.id,
                });
                this.lease_id_old = item.lease_id
                this.models.open = true;
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("PropertyHeadLeaseController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'head_lease'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            createHeadLease(){
                if(!this.models.data.property) {
                    return this.$alertNotification("Please select property!", "primary");
                }
                if(!this.models.data.head_lease) {
                    return this.$alertNotification("Please select head lease!", "primary");
                }
                let request = {
                    id: this.models.data.head_lease.id,
                    property_id: this.models.data.property.id,
                    lease_id: this.models.data.head_lease.lease_id,
                    description: this.models.data.head_lease.description,
                    start_date: this.models.data.head_lease.start_date,
                    end_date: this.models.data.head_lease.end_date,
                    option_end_date: this.models.data.head_lease.option_end_date,
                    contract_id: this.$route.params.id,
                    lease_id_old: this.lease_id_old
                }

                let keyMessage = 'adding'
                if(this.models.data.head_lease.property_id) {
                    keyMessage = 'editing'
                }
                this.$store.dispatch("PropertyHeadLeaseController/updatePropertyHeadLease", request  )
                    .then(response => {
                        this.$alertNotification(this.$notificationV2(keyMessage, 'head_lease'));
                        this.models.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                    })
                    .catch(err => {
                        if(err.response && err.response.data && err.response.data.error) {
                            this.$alertNotification(err.response.data.error.message, "danger");
                        }
                    });
            },

            /*---- Load data -----------------------*/

            loadproperty(val){
                this.models.properties.loading = true;
                this.$store.dispatch('FmCodeController/getProperties', {
                    contractId: val || this.$route.params.id,
                    propertyId: 0
                }).then(response => {
                    this.models.properties.loading = false;
                    this.models.properties.data = response;
                })
                    .catch(err => {
                        console.log(err);
                        this.models.properties.loading = false;
                        this.models.properties.data = [];
                    });
            },

            /*---- Models -----------------------*/
            hiddenModel(){
                this.models.title = "Assign Head Lease";
                this.models.data = {
                    id: null,
                    property_id: null,
                    property: null,
                    dept_code: null,
                    client_contract_id: this.$route.params.id,
                }
            },
            newItem(){
                if(this.models.properties.data.length === 0){
                    this.loadproperty();
                }
                this.lease_id_old = null
                this.models.open = true;
            },
        }
    }
</script>
